module.exports = __webpack_public_path__ + "img/BlinkArt_Bow_Basic.8fc2c0a6.png";